import type { ChinaOrderStatus } from '@igoal/shared';
import { Badge, type Tone } from './ui';

const LABEL: Record<ChinaOrderStatus, string> = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  SUPPLIER_CONFIRMED: 'Confirmed',
  PARTIALLY_FULFILLED: 'Partially confirmed',
  PACKED: 'Packed',
  PARTLY_SHIPPED: 'Partly shipped',
  SHIPPED: 'Shipped',
  RECEIVED: 'Received',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
};

const TONE: Record<ChinaOrderStatus, Tone> = {
  DRAFT: 'neutral',
  SUBMITTED: 'amber',
  SUPPLIER_CONFIRMED: 'teal',
  PARTIALLY_FULFILLED: 'violet',
  PACKED: 'teal',
  PARTLY_SHIPPED: 'amber',
  SHIPPED: 'teal',
  RECEIVED: 'success',
  REJECTED: 'danger',
  CANCELLED: 'danger',
};

export function StatusBadge({ status }: { status: ChinaOrderStatus }) {
  return <Badge tone={TONE[status]} dot>{LABEL[status]}</Badge>;
}

export const statusLabel = (s: ChinaOrderStatus) => LABEL[s];

/** The order's journey, for the progress strip on the order page */
export const JOURNEY: ChinaOrderStatus[] = ['DRAFT', 'SUBMITTED', 'SUPPLIER_CONFIRMED', 'PARTLY_SHIPPED', 'SHIPPED', 'RECEIVED'];

export function journeyIndex(status: ChinaOrderStatus): number {
  if (status === 'PARTIALLY_FULFILLED' || status === 'PACKED') return JOURNEY.indexOf('SUPPLIER_CONFIRMED');
  return JOURNEY.indexOf(status);
}
